import { useTranslation } from "react-i18next";
import footerImg from "../../assets/footerImg.png";
import EmailInput from "../emailInput/EmailInput";
import { Link } from "react-router-dom";

function Footer() {
  // Hook
  const { t, i18n } = useTranslation();

  // change language
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);

    window.scrollTo({
      behavior: "smooth",
      left: 0,
      top: 0,
    });
  };

  return (
    <div className="w-full md:mt-0 mt-10 text-white bg-footerBgColor">
      {/* Footer header section */}
      <div className="project-container w-full h-full px-4">
        <div className="md:mb-12 mb-14 text-center md:text-start">
          <h2 className="md:text-[50px] text-2xl font-semibold pt-20 pb-8">
            {t("footerHeading")}
          </h2>
          <p className="pb-8 md:text-lg text-sm text-[#A6A6A6] font-medium">
            {t("footerSubH")}
          </p>
          <img src={footerImg} alt="Footer Image" className="mx-auto md:mx-0" />
        </div>

        {/* Footer bottom section */}
        <div className="flex flex-col md:flex-row items-start justify-between">
          {/* left side */}
          <div className="md:w-6/12 mb-10 md:mb-0 text-center md:text-start">
            <img
              src="./images/logo-white.png"
              alt="logo"
              className="w-[200px]"
            />

            {/* Language Selection */}
            <div className="flex items-center gap-4">
              <p
                onClick={() => changeLanguage("gr")}
                className="mt-11 mb-7 text-[#A6A6A6] text-base cursor-pointer"
              >
                Deutsch
              </p>
              <p
                onClick={() => changeLanguage("en")}
                className="mt-11 mb-7 text-[#A6A6A6] text-base cursor-pointer"
              >
                English
              </p>
            </div>
          </div>

          {/* right side */}
          <div className="flex flex-row gap-14 justify-between md:justify-end md:items-start md:w-6/12 md:mb-32 pb-5 text-center md:text-start">
            <div className="space-y-4">
              <p className="mb-6">{t("helpHeading")}</p>
              <a
                href="mailto:info@jobdaten.com"
                className="text-[#A6A6A6] block"
              >
                {t("helpLink1")}
              </a>
              <p className="text-[#A6A6A6]">
                <Link
                  to="/impressum"
                  className="text-[#A6A6A6] hover:underline"
                >
                  {t("helpLink2")}
                </Link>
              </p>
              <p className="text-[#A6A6A6]">
                <Link
                  to="/datenschutz"
                  className="text-[#A6A6A6] hover:underline"
                >
                  {t("helpLink3")}
                </Link>
              </p>
              <p className="text-[#A6A6A6]">
                <button
                  onClick={() => {
                    if (window.klaroManager && typeof window.klaroManager.show === 'function') {
                      window.klaroManager.show();
                    } else if (window.klaro && typeof window.klaro.getManager === 'function') {
                      const manager = window.klaro.getManager();
                      if (manager && manager.modal && typeof manager.modal.show === 'function') {
                        manager.modal.show();
                      }
                    }
                  }}
                  className="text-[#A6A6A6] hover:underline cursor-pointer"
                >
                  Cookie-Einstellungen
                </button>
              </p>
            </div>

            <div className="space-y-2">
              <p className="mb-6">{t("productHeading")}</p>
              <p className="text-[#A6A6A6]">
                <Link
                  to="/blog"
                  className="text-[#A6A6A6] hover:underline block"
                >
                  Blog
                </Link>
              </p>
              <a
                href="/demo"
                className="text-[#A6A6A6] block"
              >
                {t("prodLink2")}
              </a>
              <a
                href="/demo"
                className="text-[#A6A6A6] block"
              >
                {t("prodLink3")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
